<div *ngIf="isLoading">Loading IncomeCategory List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="incomeCategory" [(ngModel)]="model.incomeCategory" [required]="required">
  <option *ngFor="let singleIncomeCategory of incomeCategories" [ngValue]="singleIncomeCategory">{{ singleIncomeCategory.name }}</option>
</select>
